import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./@Services/auth.guard";

const routes: Routes = [
  { path: "", redirectTo: "auth", pathMatch: "full" },
  {
    path: "auth",
    loadChildren: () => import("./@Auth/auth.module").then((m) => m.AuthModule),
    canActivate: [AuthGuard],
  },
  {
    path: "master",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./@Modules/master.module").then((m) => m.MasterModule),
  },
  {
    path: "assessment",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./@Assessment/assessment.module").then((m) => m.AssessmentModule),
  },
  { path: "**", redirectTo: "auth", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
